<template>
  <div>
    <h3 class="topTitle">Progreso Actual
      <b class="green"> {{sectionName}}</b></h3>
    <el-row class="roundedBorder">
      <el-col :xs="24" :sm="24" :lg="13" class="relative">
        <div class="chartContainer">
          <div id="tooltipDisplay"></div>
          <canvas :id="elementId"></canvas>
        </div>
      </el-col>
      <el-col class="allDescriptionsContainer" :xs="24" :sm="24" :lg="11">
        <div class="descriptionContainer">
          <div class="square" style="background: #AAD500;">
            <p class="percentaje">
              {{isNaN(deliveredPackages) ? 0 : deliveredPackages}}%
            </p>
          </div>
          <h4 v-if="largeText"  class="descriptionText">Ordenes Entregadas</h4>
          <h4 v-else class="descriptionText">Entregadas</h4>
        </div>
        <div class="descriptionContainer">
          <div class="square" style="background: #F55E64;">
            <p class="percentaje">
              {{isNaN(rejectedPackages) ? 0 : rejectedPackages}}%
            </p>
          </div>
          <h4 v-if="largeText" class="descriptionText">Ordenes no entregadas</h4>
          <h4 v-else class="descriptionText">No entregadas</h4>
        </div>
        <div class="descriptionContainer">
          <div class="square" style="background: #FFAB00;">
            <p class="percentaje">
              {{isNaN(delayedPackages) ? 0 : delayedPackages}}%
            </p>
          </div>
          <h4 v-if="largeText"  class="descriptionText">Ordenes Atrasadas</h4>
          <h4 v-else class="descriptionText">Atrasadas</h4>
        </div>
        <div class="descriptionContainer">
          <div class="square" style="background: #E0E0E0;">
            <p class="percentaje" style="color: #666666;">
              {{isNaN(inRoutePackages) ? 0 : inRoutePackages}}%
            </p>
          </div>
          <h4 v-if="largeText"  class="descriptionText">Ordenes en espera</h4>
          <h4 v-else class="descriptionText">En espera</h4>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Chart from 'chart.js';

export default {
  data() {
    return {
      packagesData: [],
      handlePackageLabels: ['delivered', 'delayed', 'rejected', 'in_route'],
      myChart: null,
      maxPackages: 0,
      deliveredPackages: 5,
      delayedPackages: 0,
      rejectedPackages: 0,
      inRoutePackages: 0,
    };
  },
  props: {
    largeText: {
      type: Boolean,
      default: true,
    },
    elementId: {
      type: String,
      required: true,
    },
    chartData: {
      type: Array,
      required: true,
    },
    sectionName: {
      type: String,
      required: false,
    },
  },
  methods: {
    updateChart() {
      if (this.chartData.length > 0) {
        this.maxPackages = this.chartData[0].progress.total;
        const newData = this.chartData[0].progress;
        this.handlePackageLabels.forEach((element, index) => {
          this.myChart.data.datasets.forEach((dataset) => {
            const selectedDataset = dataset.data;
            selectedDataset[index] = newData[element];
            if (element === 'in_route') {
              // minus delayed packages (index 1)
              selectedDataset[index] = newData[element] - selectedDataset[1];
            }
          });
        });
        this.myChart.update();
        this.deliveredPackages = ((this.chartData[0].progress.delivered / this.maxPackages) * 100)
          .toFixed(1);
        this.delayedPackages = ((this.chartData[0].progress.delayed / this.maxPackages) * 100)
          .toFixed(1);
        this.rejectedPackages = ((this.chartData[0].progress.rejected / this.maxPackages) * 100)
          .toFixed(1);
        this.inRoutePackages = (((this.chartData[0].progress.in_route
          - this.chartData[0].progress.delayed) / this.maxPackages) * 100)
          .toFixed(1);
      }
    },
    init() {
      if (this.chartData.length > 0) {
        const thisElement = this;
        const ctx = document.getElementById(this.elementId);
        this.maxPackages = this.chartData[0].progress.total;
        this.myChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['ENTREGADAS', 'ATRASADAS', 'NO ENTREGADAS', 'EN ESPERA'],
            datasets: [{
              data: thisElement.packagesData,
              backgroundColor: ['#AAD500', '#FFAB00', '#F55E64', '#666'],
            }],
          },
          options: {
            legend: false,
            maintainAspectRatio: false,
            tooltips: {
              enabled: false,
              intersect: false,
              mode: 'point',
              custom(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById('chartjs-tooltip');
                const tooltipContainer = document.getElementById('tooltipDisplay');
                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement('div');
                  tooltipEl.id = 'chartjs-tooltip';
                  tooltipEl.innerHTML = '<div></div>';
                  tooltipContainer.appendChild(tooltipEl);
                }
                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }
                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add('no-transform');
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  const bodyLines = tooltipModel.body.map(getBody);
                  const elTitle = tooltipModel.body[0].lines[0];
                  const indexToSubString = elTitle.indexOf(':');
                  const setNumber = elTitle.substring((indexToSubString + 1), elTitle.length);
                  const itemNumber = parseInt(setNumber, 10);
                  const itemTitle = elTitle.substring(0, indexToSubString);
                  let innerHtml = '';
                  const showPercentage = ((itemNumber / thisElement.maxPackages) * 100).toFixed(1);
                  bodyLines.forEach(() => {
                    // eslint-disable-next-line no-restricted-globals
                    const ifs = isNaN(showPercentage);
                    const bodyElement = `
                    <p class="percentageContainer"><span class="numberPercentage">${ifs ? 0 : showPercentage}%</span></p>
                    <p class="tooltipBodyTextDesign">${itemNumber}</p>`;
                    innerHtml += bodyElement;
                  });
                  tooltipModel.body.forEach(() => {
                    innerHtml += `<h4 class="tooltipTitleTextDesign"><span class="packageTitle">Ordenes</span> ${itemTitle}</h4>`;
                  });
                  const tableRoot = tooltipEl.querySelector('div');
                  tableRoot.innerHTML = innerHtml;
                }
                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.left = `${tooltipModel.caretX - 20}px`;
                tooltipEl.style.top = `${tooltipModel.caretY - 108}px`;
                tooltipEl.style.fontSize = `${tooltipModel.bodyFontSize}px`;
              },
            },
          },
        });
        this.myChart.update();
      }
    },
  },
  mounted() {
    this.init();
    this.updateChart();
  },
  watch: {
    chartData() {
      this.init();
      this.updateChart();
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/var";

  .topTitle {
    text-transform: uppercase;
    font-size: 16px;
    text-align: left;
    margin: 0 0 5px;
  }
  .roundedBorder {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 10px 10px 10px;
    border: 1px solid $fb-grey-light-84;
    border-radius: 3px;
    background: white;
    display: inline-block;
    .relative {
      position: relative;
    }
  }
  .textContainer{
    width: 1em;
    display: inline-block;
  }
  .green{
    color: $fb-green;
  }
  .verticalText {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
    margin: 0;
    color: #AAD500;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 900;
    text-align: center;
    height:250px;
  }
  .horizontalText {
    width: calc(100% - 20px);
    margin: 0;
    color: #AAD500;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 900;
    float: right;
  }
  .chartContainer {
    display: inline-block;
    height: 260px;
    width: 100%;
    position: relative;
    box-sizing: border-box;
    canvas {
      position: absolute;
      z-index: 1;
    }
  }
  .tooltipDisplay {
    position: relative;
  }
  .textContainer {
    position: absolute;
  }
  .allDescriptionsContainer {
    text-align: left;
    border: 1px solid $fb-grey-light-94;
    background: #fafafa;
    margin-top: 2em;
    padding: 2% 3%;
  }
  .square {
    width: 3em;
    height: 1.5em;
    display: inline-block;
    vertical-align: middle;
    margin-right: 2%;
    border: 1px solid $fb-grey-light-94;
    .percentaje {
      font-size: 10px;
      margin: 0;
      line-height: 23px;
      font-weight: 900;
      text-align: center;
      color: white;
    }
  }
  .descriptionText {
    display: inline-block;
    vertical-align: middle;
    text-transform: uppercase;
    font-size: 10px;
  }
  @media only screen and (max-width: 1200px) {
    .allDescriptionsContainer {
      padding: 1em 0;
    }
    .descriptionContainer {
      max-width: 200px;
      margin: 0 auto;
    }
    .chartContainer {
      max-height: 180px;
    }
  }
  @media only screen and (max-width: 425px) {
    .topTitle {
      font-size: 12px;
    }
    .verticalText,
    .horizontalText {
      font-size: 10px;
    }
  }
</style>
<style lang="scss">
  @import "../../assets/scss/var";
  #chartjs-tooltip {
    background: white;
    border: 1px solid $fb-grey-light-84;
    border-radius: 3px;
    position: absolute;
    padding: 10px;
    z-index: 2;
    &::after {
      content: '';
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      border-top: 12px solid white;
      position: absolute;
      bottom: -12px;
      left: 7px;
    }
    &::before {
      content: '';
      border-left: 13px solid transparent;
      border-right: 13px solid transparent;
      border-top: 13px solid $fb-grey-light-84;
      position: absolute;
      bottom: -13px;
      left: 6px;
    }
    .tooltipBodyTextDesign {
      font-size: 28px;
      font-weight: 900;
      margin: 0;
      color: $fb-green;
      text-align: center;
    }
    .tooltipTitleTextDesign {
      text-transform: uppercase;
      font-size: 10px;
      color: $fb-grey-light-30;
      font-weight: 900;
      margin: 0;
      text-align: center;
    }
    .packageTitle {
      display: block;
      font-weight: 300;
      letter-spacing: 1px;
    }
  }
  .percentageContainer {
    margin: 0;
    text-align: right;
  }
  .numberPercentage {
    font-size: 9px;
    color: white;
    background-color: $fb-grey-light-50;
    padding: 2px;
    font-weight: 400;
  }
</style>
